module.exports = __webpack_public_path__ + "img/bg-dashboard-lightergreen.de046d13.png";